/* Sano&Sana CRO DEMO - selettore bundle, galleria, sticky ATC. Nessuna dipendenza. */
(function () {
  'use strict';

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function drawerIsOpen(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains('active') || drawer.classList.contains('is-open')) return true;
    if (drawer.querySelector('.drawer.active, .drawer__inner.active')) return true;
    return document.body.classList.contains('overflow-hidden');
  }

  /* Rileva un menu, drawer (carrello/menu) o popup aperto, per tenere la barra
     fissa nascosta finché non viene chiuso. Controllo volutamente generico e
     "best effort": se nessuna di queste condizioni si applica al tema, non ha
     alcun effetto sul comportamento esistente. */
  function isOverlayOpen() {
    if (document.documentElement.classList.contains('overflow-hidden')) return true;
    if (document.body.classList.contains('overflow-hidden')) return true;
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) return true;
    if (document.querySelector('menu-drawer.active, header-drawer[open]')) return true;
    if (document.querySelector('dialog[open]')) return true;
    return false;
  }

  /* ---------- BOX OFFERTA ---------- */
  function initOffer(root) {
    if (root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    var isPrimary = root === document.querySelector('[data-ss-offer]');
    var inputs = root.querySelectorAll('input[type=radio][name^=ssqty]');
    var qtyField = root.querySelector('[data-ss-qty]');
    var totalEl = root.querySelector('[data-ss-total]');
    var totalWasEl = root.querySelector('[data-ss-total-was]');
    var btnPrice = root.querySelector('[data-ss-btn-price]');
    var form = root.querySelector('[data-ss-form]');
    var btn = root.querySelector('[data-ss-atc]');
    var shipNote = root.querySelector('[data-ss-ship]');

    function sync() {
      var sel = root.querySelector('input[type=radio][name^=ssqty]:checked');
      if (!sel) return;
      var qty = parseInt(sel.value, 10) || 1;
      var total = parseInt(sel.dataset.total, 10) || 0;
      var was = parseInt(sel.dataset.was, 10) || 0;
      if (qtyField) qtyField.value = qty;
      if (totalEl) totalEl.textContent = money(total);
      if (totalWasEl) {
        if (was > total) { totalWasEl.textContent = money(was); totalWasEl.style.display = 'inline'; }
        else { totalWasEl.style.display = 'none'; }
      }
      if (btnPrice) btnPrice.textContent = money(total);
      if (shipNote) shipNote.textContent = qty >= 2 ? (shipNote.dataset.free || '') : (shipNote.dataset.paid || '');
      /* Nota: la barra fissa (sticky) mostra sempre il prezzo di partenza a
         confezione singola, non il totale del bundle selezionato: resta un
         prezzo "ancora" stabile mentre l'utente confronta le opzioni. */
    }

    each(inputs, function (i) {
      i.addEventListener('change', function () {
        sync();
        // Allinea la scelta negli altri box offerta della pagina (hero e #offerta),
        // cosi la barra fissa mostra e aggiunge sempre la confezione scelta per ultima.
        if (!i.checked) return;
        each(document.querySelectorAll('[data-ss-offer]'), function (other) {
          if (other === root) return;
          var twin = other.querySelector('input[type=radio][name^=ssqty][value="' + i.value + '"]');
          if (twin && !twin.checked) {
            twin.checked = true;
            twin.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
    sync();

    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!window.routes || !window.routes.cart_add_url) return; // fallback: POST classico
      e.preventDefault();
      var oldHtml = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Aggiungo…</span>'; }

      var drawer = document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (drawer) {
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) { window.location.href = cartUrl(); return; }
          if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = cartUrl(); return; }
          try {
            var inner = drawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } catch (err) {
            window.location.href = cartUrl();
            return;
          }
          // rete di sicurezza: se il drawer non si apre, porta al carrello
          setTimeout(function () {
            if (!drawerIsOpen(drawer)) window.location.href = cartUrl();
          }, 700);
        })
        .catch(function () { window.location.href = cartUrl(); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = oldHtml; }
        });
    });
  }

  /* ---------- GALLERIA ---------- */
  function initGallery(root) {
    if (root.dataset.ssInit) return;
    root.dataset.ssInit = '1';
    var track = root.querySelector('[data-ss-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ss-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-thumb]'));

    function mark(i) {
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function go(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var idx = Math.round(track.scrollLeft / (track.clientWidth || 1));
        mark(Math.max(0, Math.min(slides.length - 1, idx)));
      }, 90);
    }, { passive: true });
    mark(0);
  }

  /* ---------- STICKY ATC ----------
     La barra si attiva quando si scorre oltre il pulsante d'acquisto dell'hero (ATF)
     e si nasconde di nuovo quando la sezione "offerta" (bundle con il proprio
     pulsante d'acquisto) torna visibile, o quando si raggiunge il footer,
     per evitare due CTA sovrapposte o di coprire il footer. Resta nascosta anche
     mentre un menu, un drawer o un popup sono aperti sopra la pagina. Il pulsante
     "Acquista ora" non aggiunge al carrello direttamente: scorre dolcemente fino
     al selettore finale delle confezioni, dove l'utente conferma l'acquisto. */
  function initSticky(bar) {
    if (bar.dataset.ssInit) return;
    bar.dataset.ssInit = '1';

    var go = bar.querySelector('[data-ss-sticky-atc]');
    if (go) {
      go.addEventListener('click', function () {
        var targetSel = bar.dataset.ssScrollTarget || '#offerta';
        var target = document.querySelector(targetSel) || document.querySelector('[data-ss-offer]');
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var anchor = document.querySelector(bar.dataset.ssAfter || '[data-ss-atc]');
    var offerSection = document.getElementById(bar.dataset.ssHideOn || 'offerta');
    var footerSection = document.querySelector(bar.dataset.ssHideOnFooter || '.footer');

    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }

    var pastAtc = false;
    var offerVisible = false;
    var footerVisible = false;

    function update() {
      bar.classList.toggle('is-on', pastAtc && !offerVisible && !footerVisible && !isOverlayOpen());
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        pastAtc = !en.isIntersecting && below;
      });
      update();
    }, { threshold: 0 });
    io.observe(anchor);

    if (offerSection) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          offerVisible = en.isIntersecting;
        });
        update();
      }, { threshold: 0.15 });
      io2.observe(offerSection);
    }

    if (footerSection) {
      var io3 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          footerVisible = en.isIntersecting;
        });
        update();
      }, { threshold: 0 });
      io3.observe(footerSection);
    }

    /* Ricontrolla quando un drawer/menu/popup si apre o si chiude (cambio di
       classe su html/body), cosi la barra si nasconde e riappare correttamente
       senza dover attendere uno scroll. */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { update(); });
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function boot() {
    each(document.querySelectorAll('[data-ss-offer]'), initOffer);
    each(document.querySelectorAll('[data-ss-gallery]'), initGallery);
    each(document.querySelectorAll('[data-ss-sticky]'), initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
